<script>
	import Accordion from './Accordion.svelte';

	const items = [
		{
			title: 'Consumer Notice',
			content: `<p>
			Personal Information you submit through our Sites, such as your name,
			address and other contact information, may be collected by West Coast
			University for internal marketing and development purposes as well as to
			respond to your inquiry, complete a transaction for you, or fulfill other
			forms of customer service. You can choose not to receive marketing from us
			by “unsubscribing” using the instructions in any marketing email you
			receive from us.
		</p>
		<p>
			<a
				href="/legal/privacy-policy#ccpa"
				>Click here to learn more</a>
		</p>`,
		},
	];
</script>

<div class="consumer-notice" style="margin-top: 12px;">
	<Accordion {items} />
</div>
